module.exports = __webpack_public_path__ + "assets/b42c8448032a5bd3b088f8bf9437edfa.mp4";